var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-bullets"},_vm._l((_vm.total),function(index){return _c('div',{key:index,staticClass:"slide-bullets__bullet",class:_vm.current === index - 1 ? '--active' : ''})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }